import { Contract } from '../entities/contract-entity';
import { Delete } from '../entities/delete-entity';
import { ContractRepository } from '../repositories/contract-repository';

interface ContractUsecase {
  CreateContract(promisor_id: string, promisee_id: string): Promise<Contract>;
  GetContracts(client_id: string): Promise<Contract[]>;
  GetContract(client_id: string, contract_id: string): Promise<Contract>;
  DeleteContract(contract_id: string): Promise<Delete>;
}

export class ContractUsecaseImpl implements ContractUsecase {
  contractRepository: ContractRepository;

  constructor(cr: ContractRepository) {
    this.contractRepository = cr;
  }

  CreateContract(promisor_id: string, promisee_id: string): Promise<Contract> {
    return this.contractRepository.CreateContract(promisor_id, promisee_id);
  }

  GetContracts(client_id: string): Promise<Contract[]> {
    return this.contractRepository.GetContracts(client_id);
  }

  GetContract(client_id: string, contract_id: string): Promise<Contract> {
    return this.contractRepository.GetContract(client_id, contract_id);
  }

  DeleteContract(contract_id: string): Promise<Delete> {
    return this.contractRepository.DeleteContract(contract_id);
  }
}
